// "성수동 브런치" 처럼 지역이 인식된 검색이면, 서버가 그 지역의 중심과 경계를 함께 준다.
// 지도를 그 동네로 옮기고 상자에 맞춰 확대 수준을 정한다(2026-07-31).
export const getZoomForAreaBounds = (bbox) => {
  if (!bbox) return 15;
  const latSpan = Math.abs(Number(bbox.maxLat) - Number(bbox.minLat));
  const lngSpan = Math.abs(Number(bbox.maxLng) - Number(bbox.minLng));
  const span = Math.max(latSpan, lngSpan);
  if (!Number.isFinite(span) || span <= 0) return 15;
  if (span > 0.2) return 11;
  if (span > 0.1) return 12;
  if (span > 0.05) return 13;
  if (span > 0.02) return 14;
  if (span > 0.01) return 15;
  return 16;
};
